import { FileDown, UserRound, LayoutGrid, ArrowDown } from "lucide-react";
import { useFetch } from "../../lib/hooks";
import { downloadFile } from "../common/DataActions";
import { Button } from "../ui/button";
import { Hi } from "./GuideParts";

export function CycleGuide({ kw }) {
  const { data } = useFetch("/guide/cycle");
  if (!data) return null;
  const items = data.cycle.filter((c) => !kw || [c.title, c.actor, c.menu, c.sample, ...c.steps].some((x) => x.toLowerCase().includes(kw)));
  return (
    <div data-testid="guide-cycle">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <h2 id="guide-cycle" className="section-title">Satu siklus lengkap — contoh siswa <span className="text-[color:var(--brand-blue)]">{data.student}</span></h2>
        <Button size="sm" variant="outline" data-testid="guide-export-pdf" onClick={() => downloadFile("/guide/pdf", "panduan_ylms_siklus.pdf")}><FileDown className="h-4 w-4 mr-1" />Export PDF</Button>
      </div>
      <div className="surface p-4 mb-4 text-sm text-slate-700 leading-relaxed border-l-4 border-l-[color:var(--brand-blue)]" data-testid="guide-cycle-summary"><Hi text={data.summary} kw={kw} /></div>
      <ol className="space-y-3 mb-8">
        {items.map((c, i) => (
          <li key={c.no} className="surface overflow-hidden reveal" style={{ animationDelay: `${i * 40}ms` }} data-testid={`guide-cycle-step-${c.no}`}>
            <div className="flex flex-wrap items-center gap-3 px-4 py-2.5 bg-[color:var(--brand-blue)] text-white">
              <span className="h-7 w-7 shrink-0 rounded-full bg-white/20 grid place-items-center font-heading font-bold text-sm">{c.no}</span>
              <p className="font-heading font-bold flex-1 min-w-[160px]"><Hi text={c.title} kw={kw} /></p>
              <span className="inline-flex items-center gap-1 text-[11px] opacity-90"><UserRound className="h-3.5 w-3.5" /><Hi text={c.actor} kw={kw} /></span>
              <span className="inline-flex items-center gap-1 text-[11px] opacity-90"><LayoutGrid className="h-3.5 w-3.5" /><Hi text={c.menu} kw={kw} /></span>
            </div>
            <div className="p-4 grid gap-3 md:grid-cols-[1fr_320px]">
              <ul className="space-y-1.5">{c.steps.map((s) => <li key={s} className="text-sm text-slate-700 flex gap-2"><span className="text-[color:var(--brand-blue)] font-bold">›</span><span><Hi text={s} kw={kw} /></span></li>)}</ul>
              <div className="rounded-lg bg-sky-50 dark:bg-sky-950/40 border border-sky-200 p-3 text-xs text-sky-900 dark:text-sky-100"><p className="font-semibold mb-1">Contoh {data.student}</p><Hi text={c.sample} kw={kw} /></div>
            </div>
            {i < items.length - 1 && <div className="flex justify-center -mb-2 text-slate-300"><ArrowDown className="h-4 w-4" /></div>}
          </li>
        ))}
      </ol>
    </div>
  );
}
